import { render, staticRenderFns } from "./ViewDemandAgency.vue?vue&type=template&id=05a20762&scoped=true&"
import script from "./ViewDemandAgency.vue?vue&type=script&lang=js&"
export * from "./ViewDemandAgency.vue?vue&type=script&lang=js&"
import style0 from "./ViewDemandAgency.vue?vue&type=style&index=0&id=05a20762&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a20762",
  null
  
)

export default component.exports